/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerCancelRequestMutationResponse, MultiDocumentAgentControllerCancelRequestPathParams, MultiDocumentAgentControllerCancelRequest401, MultiDocumentAgentControllerCancelRequest403, MultiDocumentAgentControllerCancelRequest404 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerCancelRequest";

function getMultiDocumentAgentControllerCancelRequestUrl(requestId: MultiDocumentAgentControllerCancelRequestPathParams["requestId"]) {
  const res = { method: 'POST', url: `/api/v1/multi-document-agent/cancel/${requestId}` as const }  
  return res
}

/**
 * @summary Cancel a running chat request
 * {@link /api/v1/multi-document-agent/cancel/:requestId}
 */
export async function multiDocumentAgentControllerCancelRequest(requestId: MultiDocumentAgentControllerCancelRequestPathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerCancelRequestMutationResponse, ResponseErrorConfig<MultiDocumentAgentControllerCancelRequest401 | MultiDocumentAgentControllerCancelRequest403 | MultiDocumentAgentControllerCancelRequest404>, unknown>({ method : "POST", url : getMultiDocumentAgentControllerCancelRequestUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}